import AppLoader from "./AppLoader";

const AppLoaderFUllPage = () => {
  return (
    <div
      data-testid="suspense-fallback"
      className="h-screen flex justify-center items-center w-full  bg-body/50"
    >
      <AppLoader />
    </div>
  );
};

export default AppLoaderFUllPage;
